import { render, staticRenderFns } from "./ConfirmPrescriptionModal.vue?vue&type=template&id=63dd7e06&"
import script from "./ConfirmPrescriptionModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmPrescriptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports